<template>
  <footer v-if="currentRouteName != '404'" class="site-footer">
    <img
      src="https://asset.hankooktire.com/content/dam/hankooktire/local/img/main/main-key-visual/pc/logo.svg"
      alt="Hankook"
      class="site-footer__logo"
    />
    <ul class="site-footer__links">
      <li>
        <a
          href="https://oxoformdocs.fra1.digitaloceanspaces.com/69c0f9282be14f242c26312a/modalites.pdf"
          target="_blank"
          class="site-footer__link"
          >Mentions Légales</a
        >
      </li>
      <li>
        <a
          href="https://oxoformdocs.fra1.digitaloceanspaces.com/69c0f9282be14f242c26312a/politique.pdf"
          target="_blank"
          class="site-footer__link"
          >Politique de Confidentialité</a
        >
      </li>
    </ul>
    <div class="site-footer__copyright">
      © 2026 Tous droits réservés.
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>

<style>
.site-footer {
  position: relative;
  z-index: 60;
  background: #1A1A1A;
  border-top: 1px solid #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  gap: 24px;
  flex-wrap: wrap;
}

.site-footer__logo {
  height: 40px;
  filter: brightness(0) invert(1);
}

.site-footer__links {
  display: flex;
  gap: 24px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.site-footer__link {
  color: #EC6608;
  font-size: 13px;
  text-decoration: none;
}

.site-footer__link:hover {
  text-decoration: underline;
}

.site-footer__copyright {
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
}
</style>
